import { CACHE_TTL_MS, SPECS } from '../../constants';
var ViewerStorage = /** @class */ (function () {
    function ViewerStorage(_a) {
        var cacheKey = _a.cacheKey, _b = _a.clearOnRefresh, clearOnRefresh = _b === void 0 ? true : _b, storage = _a.storage, siteStore = _a.siteStore;
        var _this = this;
        this.cacheKey = cacheKey;
        this.storage = storage;
        this.siteStore = siteStore;
        if (this.siteStore.experiments.enabled(SPECS.UseSessionStorageForCartCache) && clearOnRefresh) {
            this.clearOnReload();
            siteStore.location.onChange(function () {
                _this.storage.session.setItem(_this.getLastUrlCacheKey(), _this.siteStore.location.url);
            });
        }
    }
    ViewerStorage.prototype.get = function () {
        if (!this.siteStore.experiments.enabled(SPECS.UseSessionStorageForCartCache)) {
            var item_1 = this.storage.memory.getItem(this.cacheKey);
            if (!item_1) {
                return;
            }
            return JSON.parse(item_1);
        }
        var item;
        try {
            item = this.storage.session.getItem(this.cacheKey);
        }
        catch (_a) {
            item = undefined;
        }
        if (!item) {
            return;
        }
        var parsed;
        try {
            parsed = JSON.parse(item);
        }
        catch (_b) {
            return;
        }
        if (this.siteStore.experiments.enabled(SPECS.UseSessionStorageForCartCache)) {
            var isExpired = Date.now() - parsed.timestamp > CACHE_TTL_MS;
            if (isExpired) {
                this.remove();
                return;
            }
        }
        return parsed.item;
    };
    ViewerStorage.prototype.set = function (item) {
        if (!this.siteStore.experiments.enabled(SPECS.UseSessionStorageForCartCache)) {
            try {
                this.storage.memory.setItem(this.cacheKey, JSON.stringify(item));
            }
            catch (_a) {
                this.storage.memory.removeItem(this.cacheKey);
            }
            return;
        }
        var cachedItem = {
            item: item,
            timestamp: Date.now(),
        };
        try {
            this.storage.session.setItem(this.cacheKey, JSON.stringify(cachedItem));
        }
        catch (_b) {
            this.remove();
        }
    };
    ViewerStorage.prototype.remove = function () {
        if (!this.siteStore.experiments.enabled(SPECS.UseSessionStorageForCartCache)) {
            this.storage.memory.removeItem(this.cacheKey);
            return;
        }
        this.storage.session.removeItem(this.cacheKey);
    };
    ViewerStorage.prototype.clearOnReload = function () {
        var lastUrlCacheKey = this.getLastUrlCacheKey();
        var url = this.siteStore.location.url;
        var lastUrl;
        var hadError = false;
        try {
            lastUrl = this.storage.session.getItem(lastUrlCacheKey);
        }
        catch (_a) {
            hadError = true;
        }
        var isReload = url === lastUrl;
        if (isReload || hadError) {
            this.remove();
            this.storage.session.removeItem(lastUrlCacheKey);
        }
        this.storage.session.setItem(lastUrlCacheKey, url);
    };
    ViewerStorage.prototype.getLastUrlCacheKey = function () {
        return "".concat(this.cacheKey, "-lastUrl");
    };
    return ViewerStorage;
}());
export { ViewerStorage };
//# sourceMappingURL=ViewerStorage.js.map